import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=2e2c0f3d&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e2c0f3d')) {
      api.createRecord('2e2c0f3d', component.options)
    } else {
      api.reload('2e2c0f3d', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=2e2c0f3d&", function () {
      api.rerender('2e2c0f3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8iB4P35ZhSPWp/JS/comp/IncreaseNumber.vue"
export default component.exports